/* eslint-disable @typescript-eslint/no-explicit-any */
import Col from "antd/lib/col";
import Layout from "antd/lib/layout";
import Row from "antd/lib/row";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import { routes } from "../../../config/route-config";
import { getActiveMenu } from "../../../helpers/getActiveMenu";
import { manageSidebarMenus, moreSidebarMenus } from "../../../helpers/menus";
import { SelectedDepotTypes } from "../../../lib/types/depots";
import { COLOR_VALUES } from "../../../lib/types/shared/enums";
import RoleBased from "../RoleBasedAccess";
import { G_Text } from "../Text";
import SingleMenuItem from "./SingleMenuItem";
const { Sider } = Layout;

/**
 * @since February 2024
 * @author Issa Jean Marie <jeanmarieissa@gmail.com>
 * @see {@link https://issadevs.com} - Author's website
 * @returns {JSX.Element}
 */

const AppSider = (): JSX.Element => {
  const depotsState = useSelector(
    (state: { depots: { payload: SelectedDepotTypes } }) =>
      state?.depots?.payload
  );

  const menuItems = manageSidebarMenus();
  const moreMenus = moreSidebarMenus();
  const router = useRouter();
  const menuCategories = [
    {
      title: "Dashboard",
      menu: menuItems
    },
    {
      title: "Manage",
      menu: moreMenus
    }
  ];

  return (
    <>
      <Sider
        style={{
          background: COLOR_VALUES.ox_2_dark_blue,
          height: "calc(100vh - 48px)"
        }}
        className="overflow-auto"
        width={250}
      >
        {menuCategories?.map((cat) => (
          <>
            <Row className="p-6 px-8">
              <Col>
                <G_Text dimension="caption">
                  <span className="text-gray-400">{cat.title}</span>
                </G_Text>
              </Col>
            </Row>

            {cat.menu?.map((menu) => {
              const { isThisMenuActive } = getActiveMenu({
                menu,
                router
              });

              if (menu.url === routes.EBM.url) {
                return (
                  <RoleBased
                    key={menu.name}
                    accessLevels={["VIEW_EBM_RECORDS"]}
                  >
                    <SingleMenuItem
                      isThisMenuActive={isThisMenuActive}
                      menu={menu}
                    />
                  </RoleBased>
                );
              }

              return (
                <SingleMenuItem
                  key={menu.name}
                  isThisMenuActive={isThisMenuActive}
                  menu={
                    menu.name === routes.DepotProfile.name
                      ? { ...menu, url: `${menu.url}/${depotsState.depotId}` }
                      : menu
                  }
                />
              );
            })}
          </>
        ))}
      </Sider>
    </>
  );
};

export default AppSider;
